// import React, { useContext } from "react";
// import Header from "../Components/Header";
// import Rightcontainer from "../Components/Rightcontainer";
// import { Link } from "react-router-dom";
// import { LanguageContext } from "../Components/LanguageContext";
// import { useTheme } from "../../ThemeContext";

// const Support = ({ handleShow }) => {
//   const theme = localStorage.getItem('theme')

//   // language 
//   const translations = {
//     hi: {
//       contact: 'नीचे दिए गए प्लेटफ़ॉर्म पर हमसे संपर्क करें।',
//       money: 'राशि डालें  ',
//       next: 'आगे बड़े ',
//       addAmount: 'राशि जोड़ी जानी है ',
//       referPerson: 'रेफ़रल | ',
//     },
//     en: {
//       contact: 'Contact Us At Below Platforms.',
//       money: 'Enter Amount',
//       next: 'Next',
//       addAmount: 'Amount to be added',
//       referPerson: 'Referral',
//     },
//   };

//   const { language } = useContext(LanguageContext);


//   // change theme 
//   const styles = {
//     backgroundColor: theme === 'light' ? '#d3e3fd' : 'black',
//     color: theme === 'light' ? 'black' : '#fff',
//   };
//   const styles1 = {
//     color: theme === 'light' ? 'black' : 'white',
//   };

//   return (
//     <div>
//       <div
//         className="leftContainer pt-5 mt-5"
//         style={styles}
//       >
//         <div className="supportNewLayout">

//           {/* TOP INFO CARD */}
//           <div className="helpTopCard">
//             <div className="helpLeftBar"></div>

//             <div className="helpContent">
//               <img src="./images/support.jpg" className="helpImg" />
//               <div>
//                 <h2 className="helpTitle">Need Help?</h2>
//                 <p className="helpSub">We are here for you 24/7</p>
//               </div>
//             </div>
//           </div>

//           {/* SUPPORT GRID */}
//           <div className="supportOptionGrid">

//             {/* Teligram */}
//             <a className="supportOptionCard" href={JSON.parse(localStorage.getItem("sitSetting")).supportTelegram}>
//               <div className="supportIcon emailBG">
//                 <img src="./images/telegram.png" alt="" />
//               </div>
//               <div className="supportText">
//                 <h5>Telegram Support</h5>
//                 <span>Expect a quick response</span>
//               </div>
//             </a>

//             {/* WhatsApp */}
//             {JSON.parse(localStorage.getItem("sitSetting"))?.whatsappSupport && (
//               <a
//                 className="supportOptionCard"
//                 target="_blank"
//                 href={JSON.parse(localStorage.getItem("sitSetting")).whatsappSupport}
//               >
//                 <div className="supportIcon">
//                   <img src="/images/whatsapp-new-.png" alt="" />
//                 </div>
//                 <div className="supportText">
//                   <h5>WhatsApp</h5>
//                   <span>Chat with us instantly</span>
//                 </div>
//               </a>
//             )}




//           </div>

//           {/* Email */}
//           {/* <a className="supportOptionCard" href="mailto:support@gmail.com">
//               <div className="supportIcon emailBG">
//                 <img src="./images/mail-new.png" alt="" />
//               </div>
//               <div className="supportText">
//                 <h5>Email Support</h5>
//                 <span>Expect a quick response</span>
//               </div>
//             </a> */}

//           {/* PHONE SUPPORT */}
//           {/* <div className="phone-banner">

//             <div className="phone-anim">
//               <img src="/images/phone.png" alt="" />
//             </div>

//             <div className="phone-content">
//               <span>Need direct help?</span>
//               <h4 style={{ margin: 0, fontWeight: 700 }}>Phone Support</h4>

//               <a
//                 className="phone-number"
//                 href={
//                   "tel:" +
//                   JSON.parse(localStorage.getItem("sitSetting"))?.CompanyMobile
//                 }
//                 target="_blank"
//               >
//                 {JSON.parse(localStorage.getItem("sitSetting"))?.CompanyMobile}
//               </a>
//             </div>

//             <a
//               href={
//                 "tel:" +
//                 JSON.parse(localStorage.getItem("sitSetting"))?.CompanyMobile
//               }
//               className="call-btn"
//             >
//               Call Now
//             </a>

//           </div> */}

//         </div>

//       </div>
//       <div className="rightContainer">
//         <Rightcontainer />
//       </div>
//     </div>
//   );
// };

// export default Support;

import React, { useContext } from "react";
import Rightcontainer from "../Components/Rightcontainer";
import { LanguageContext } from "../Components/LanguageContext";
import { BsArrowRightShort } from "react-icons/bs";
// import "./SupportUI.css"; 

const Support = () => {
  const { language } = useContext(LanguageContext);
  const siteSetting = JSON.parse(localStorage.getItem("sitSetting")) || {};

  const translations = {
    hi: {
      help: 'सपोर्ट सेंटर',
      sub: 'हम आपकी सहायता के लिए 24x7 यहां हैं',
      team: 'हमारी सहायता टीम',
      replies: 'आमतौर पर 2 मिनट में उत्तर देता है',
      telegram: 'Telegram Support',
      official: 'Official Channel',
      contact: 'Contact Us',
      voice: 'Voice Assistance',
      secure: 'SECURE & VERIFIED SUPPORT'
    },
    en: {
      help: 'SUPPORT CENTER',
      sub: 'We are available 24x7 to help you',
      team: 'Our Support Team',
      replies: 'Typically replies in 2 mins',
      telegram: 'Telegram Support',
      official: 'Official Channel',
      contact: 'Contact Us',
      voice: 'Voice Assistance',
      secure: 'SECURE & VERIFIED SUPPORT'
    },
  };

  const t = translations[language] || translations.en;

  return (
    <div className="mlk_support_wrapper">
      <div className="mlk_support_content">

        {/* Title */}
        <div className="mlk_support_header">
          <h1>
            SUPPORT <span>CENTER</span>
          </h1>
          <p>{t.sub}</p>
        </div>

        {/* Team Card */}
        <div className="mlk_support_team_card">

          <div className="mlk_support_avatar_box">
            <img
              src="/images/support.jpg"
              alt="Support"
              className="mlk_support_avatar"
            />

            <div className="mlk_support_online"></div>
          </div>

          <div className="mlk_support_team_info">
            <h4>{t.team}</h4>
            <p>{t.replies}</p>
          </div>

        </div>

        {/* Links */}

        <div className="mlk_support_links">

          {siteSetting.supportTelegram && (
            <a
              href={siteSetting.supportTelegram}
              className="mlk_support_btn"
              target="_blank"
              rel="noreferrer"
            >
              <div className="mlk_support_icon">
                <img src="/tel.png" alt="" />
              </div>

              <div className="mlk_support_text">
                <h4>{t.telegram}</h4>
                <span>{t.official}</span>
              </div>

              <BsArrowRightShort className="mlk_support_arrow" />
            </a>
          )}

          {siteSetting.whatsappSupport && (
            <a
              href={siteSetting.whatsappSupport}
              className="mlk_support_btn"
              target="_blank"
              rel="noreferrer"
            >
              <div className="mlk_support_icon">
                <img src="/whatsapp.png" alt="" />
              </div>

              <div className="mlk_support_text">
                <h4>{t.contact}</h4>
                <span>{t.voice}</span>
              </div>

              <BsArrowRightShort className="mlk_support_arrow" />
            </a>
          )}

        </div>

        <div className="mlk_support_footer">
          {t.secure}
        </div>

      </div>

      <div className="rightContainer hidden-mobile">
        <Rightcontainer />
      </div>
    </div>
  );
};

export default Support;
